import Gradient from './Gradient'

export * from './Gradient'

export default Gradient
